import React from "react"
import { useTranslation } from "react-i18next"
import { CloseLarge, InfoFill } from "@/skylticons"

interface ResetTooltipProps {
  closeTooltip: () => void
}

const ResetTooltip: React.FC<ResetTooltipProps> = ({ closeTooltip }) => {
  const { t } = useTranslation()

  return (
    <div className="reset-tooltip absolute top-[67px] z-50 lg:top-[60px] lg:w-[375px]">
      <div className="ml-1 mr-2 flex rounded-lg border bg-info-bg p-3 lg:mx-0">
        <span className="tooltip-arrow"></span>
        <InfoFill className="mr-3 text-info" />
        <div className="flex flex-col text-base">
          <div className="font-semibold">{t("signomatic.reset_tooltip_title")}</div>
          <div>{t("signomatic.reset_tooltip_text")}</div>
        </div>
        <button onClick={closeTooltip} className="button button-subtle icon-only -mr-3 -mt-3" type="button">
          <CloseLarge />
        </button>
      </div>
    </div>
  )
}

export default ResetTooltip
